import Premium from 'assets/icons/premium.svg'

export default Premium
